import apiInstance from 'src/apis/config/axiosConfig';

export interface FrontDeskCallData {
  hostUrl: string;
  meetRoomName: string;
  participantName: string;
  jwtToken: string;
  sipCall?: {
    attempted?: boolean;
    attemptedCount?: number;
    successCount?: number;
  };
  operationLogId?: string;
}

export function callTenantFromFrontDesk(payload: {
  deviceId: string;
  roomId: string;
  user_ids: string[];
  source: 'FRONT_DESK';
}) {
  return apiInstance.post<{success: boolean; message?: string; data?: FrontDeskCallData}>(
    '/intercom_device/call_tenant',
    payload
  );
}

export function attachFrontDeskCallPhoto(operationLogId: string, eventPhoto: Blob | File) {
  const formData = new FormData();
  formData.append('operationLogId', operationLogId);
  formData.append('eventPhoto', eventPhoto, 'snapshot.jpg');
  return apiInstance.post<{success: boolean; message?: string}>(
    '/intercom_device/front_desk_call_photo',
    formData
  );
}

export function openDoorFromFrontDesk(payload: {deviceId: string; source: 'FRONT_DESK'}) {
  return apiInstance.post<{success: boolean; message?: string}>(
    '/intercom_device/manager/open_door',
    payload
  );
}

export function listCbwDevices(orgId: string) {
  return apiInstance.get<{
    success: boolean;
    data?: {
      devices?: Array<{
        id?: string;
        entrio_cbw_intercom_relay_links?: Array<{
          intercom_device_id?: string;
          entrio_intercom_devices?: {id?: string};
        }>;
      }>;
    };
  }>('/cbw-devices', {params: {orgId, page: 1, limit: 500}});
}
